/* @flow */
import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

const Columns = ({
  order,
  sort,
}: any): React.Element => (
  <THead>
    <Tr>
      <Th
        field="error_type"
        order={order}
        sort={sort}
        sortable
        useSortBy
        style={{ paddingLeft: '2.8rem' }}
        >
        Error Type
      </Th>

      <Th
        field="severity"
        order={order}
        sort={sort}
        useSortBy
        sortable
        >
        Severity
      </Th>

      <Th>Description</Th>

      <Th
        field="node_id"
        order={order}
        sort={sort}
        sortable
        useSortBy
        >
        Node
      </Th>

      <Th>Related Nodes</Th>

      <Th
        field="submitter_id"
        order={order}
        sort={sort}
        sortable
        useSortBy
        >
        Submitter ID
      </Th>
    </Tr>
  </THead>
);

export default Columns;
